import Servico from './Servico'

class UsuarioBloqueioServico extends Servico {
  constructor() {
    super('usuarioBloqueio')
  }
}

export default UsuarioBloqueioServico
